export default __webpack_public_path__ + "static/media/pay.9b6b614d.png";